// extracted by mini-css-extract-plugin
export default {"container":"AccountLink_container__BmOlI","label":"AccountLink_label__CYjYd","icon":"AccountLink_icon__XLTAf"};